<template>
  <div>
    <div class="flex-container align-center banner-homepage">
      <div class="container">
        <div class="font-40 color-blue-dark font-w-bold mb-56">
          {{ $t('landing_page.helping_merchants') }}<br/>
          {{ $t('landing_page.to_open') }}<br/>
          {{ $t('landing_page.new_opportunities') }}<br/>
        </div>
        <router-link to="/login">
          <el-button type="primary">
            {{ $t('landing_page.button_get_access') }}
          </el-button>
        </router-link>
      </div>
      <img src="@/assets/images/hm-section-one.png">
    </div>

    <div class="py-88">
      <div class="container">
        <div class="flex-container align-center">
          <div style="max-width: 536px; width: 100%;">
            <h3>{{ $t('landing_page.about_olsera') }}</h3>
            <p class="font-20">{{ $t('landing_page.about_detail') }}</p>
          </div>
          <el-image src="/img/assets/hm-section-two.png" fit="cover" />
        </div>
      </div>
    </div>

    <div style="background-color: #F6FDFF;" class="py-88">
      <div class="container">
        <h3 class="mb-64">{{ $t('landing_page.features.title') }}</h3>
        <el-row>
          <el-col
            v-for="(item, key) in features"
            :key="key"
            :md="12"
            class="mb-70">
            <div class="flex-container">
              <div>
                <img
                  :src="'/img/assets/hm-icon-' + (key + 1) + '.png'"
                  width="88"
                  class="flex-shrink-0">
              </div>
              <div class="ml-24" style="max-width: 340px;">
                <div class="font-20 font-w-bold mb-8">{{ item.title }}</div>
                <div class="font-16">{{ item.description }}</div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div style="background-color: #E4F8FF" class="py-88">
      <div class="container text-center">
        <h3 class="color-blue-dark">{{ $t('landing_page.join_open_api') }}</h3>
        <div class="font-18 color-blue-dark font-w-semi-bold mb-24">
          {{ $t('landing_page.description') }}
        </div>
        <router-link to="/login">
          <el-button type="primary">
            {{ $t('landing_page.button_get_access') }}
          </el-button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const features = ref([])
onMounted(() => {
  features.value = [
    {
      title: t('landing_page.features.open_api'),
      description: t('landing_page.features.open_api_desc')
    },
    {
      title: t('landing_page.features.testing_account'),
      description: t('landing_page.features.testing_account_desc')
    },
    {
      title: t('landing_page.features.technical_support'),
      description: t('landing_page.features.technical_support_desc')
    },
    {
      title: t('landing_page.features.service_market'),
      description: t('landing_page.features.service_market_desc')
    }
  ]
})
</script>
